<template lang="html">
    <div id="prices-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-extrasizes"    v-bind:to="{ name: 'Extrasizes'}"    md-label="Список"></md-tab>
            <md-tab id="tab-wayextrasizes" v-bind:to="{ name: 'WayExtrasizes'}" md-label="Список по направлениям"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'user-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// FreightExtrasizesMenu.vue?645ef9a5